export default __webpack_public_path__ + "static/media/3StackRed.030ee0aa.png";